import { render, staticRenderFns } from "./ProductOpinion.vue?vue&type=template&id=327b4b11"
import script from "./ProductOpinion.vue?vue&type=script&lang=js"
export * from "./ProductOpinion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports